export const QC_APP_ID = '101478665';
export const QC_REDIRECT_URI = 'http://xinyue.qq.com/comm-htdocs/login/qc_redirect.html';
export const WX_APP_ID = 'wx5f930f997198dbd6';
export const WX_GAME_DOMAIN = 'xinyue.qq.com';
export const IOS_DOWNLOAD_URL = '//itunes.apple.com/cn/app/%E5%BF%83%E6%82%A6%E4%BF%B1%E4%B9%90%E9%83%A8-%E8%85%BE%E8%AE%AF%E6%B8%B8%E6%88%8F%E7%8E%A9%E5%AE%B6%E7%A6%8F%E5%88%A9%E5%B9%B3%E5%8F%B0/id1156439976?mt=8';
export const ANDROID_DOWNLOAD_URL = '//sj.qq.com/myapp/detail.htm?apkName=com.tencent.tgclub';
export const UNIVERSAL_LINK = '//static.xinyue.qq.com/iosredirect';
export const XY_APP_ICON = 'https://dlied5.myapp.com/myapp/6337/tgclub/png/20200218/b8852a03f5a132aeb89b19112726755d.png';
export default {
  QC_APP_ID,
  QC_REDIRECT_URI,
  WX_APP_ID,
  WX_GAME_DOMAIN,
  IOS_DOWNLOAD_URL,
  ANDROID_DOWNLOAD_URL,
  UNIVERSAL_LINK,
  XY_APP_ICON,
};
